<template>
	<section id="calc-app">
		<router-view v-if="viewableCalc == 'all'"></router-view>
		<router-view v-else :name="viewableCalc"></router-view>
	</section>
</template>

<script>
export default {
	data: () => ({
		viewableCalc: process.env.VUE_APP_SHOW_CALC, // Set var in .env file
	}),
};
</script>
